import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isProductCatalogSlug } from '../../data/productsCatalogData'
import {
  scheduleScrollReset,
  scrollToHashTarget,
  scrollWindowToTop,
} from '../../utils/scrollToTop'

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const catalogSlug = hash.replace(/^#/, '')
  const isProductsCatalogLink =
    pathname === '/products' && catalogSlug && isProductCatalogSlug(catalogSlug)

  useLayoutEffect(() => {
    if (isProductsCatalogLink) {
      return
    }

    if (hash) {
      if (!scrollToHashTarget(hash)) {
        scrollWindowToTop()
      }
      return
    }

    scrollWindowToTop()
  }, [pathname, hash, isProductsCatalogLink])

  useEffect(() => {
    if (isProductsCatalogLink) {
      return
    }

    scheduleScrollReset({
      hash,
      delays: hash ? [100, 350, 700, 1200] : [0, 100, 300, 600, 1000],
    })
  }, [pathname, hash, isProductsCatalogLink])

  return null
}

export default ScrollToTop
